/**
 * Created by User on 17/02/2016.
 */
export default Observer;

function Observer() {

}
Observer.initialize = function(observer) {
  if (observer) {
    Observer._observer = observer;
    Observer._initialized = true;
  }
};

Observer.emit = function(eventType, params) {
  if (Observer._initialized) {
    Observer._observer.emit(eventType, params);
  }
};

Observer.on = function(eventType, callback) {
  if (Observer._initialized) {
    if (Array.isArray(eventType)) {
      Observer._onEventsFromArray(eventType, callback);
    } else {
      Observer._observer.on(eventType, callback);
    }
  }
};

Observer.off = function(eventType, callback) {
  if (Observer._initialized) {
    if (Array.isArray(eventType)) {
      Observer._offEventsFromArray(eventType, callback);
    } else {
      Observer._observer.off(eventType, callback);
    }
  }
};

Observer.getObserverInstance = function() {
  return Observer._observer;
};

Observer._onEventsFromArray = function(eventTypes, callback) {
  for (var i = 0, l = eventTypes.length; i < l; ++i) {
    Observer.on(eventTypes[i], callback);
  }
};

Observer._offEventsFromArray = function(eventTypes, callback) {
  for (var i = 0, l = eventTypes.length; i < l; ++i) {
    Observer.off(eventTypes[i], callback);
  }
};

Observer._initialized = false;
Observer._observer = null;

